var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSwap(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.051,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B0A8F0",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20.37a10.54 10.54 0 01-1.919 6.07 10.007 10.007 0 01-5.012 3.74 9.686 9.686 0 01-6.184-.025 10.013 10.013 0 01-4.983-3.78 10.543 10.543 0 01-1.873-6.086c.015-2.182.7-4.303 1.957-6.058a10 10 0 015.035-3.706 9.686 9.686 0 016.183.066 10.032 10.032 0 014.92 3.761A10.557 10.557 0 0130 20.37z",
    fill: "#536AEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.044 19.09a10.044 10.044 0 11-20.088.01 10.044 10.044 0 0120.088-.01z",
    fill: "#798BF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.292 12.188L11.439 24.345a10.044 10.044 0 0115.853-12.157z",
    fill: "#9AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.113 12.574v.53a1.242 1.242 0 01-.78 1.165 2.254 2.254 0 00-1.462 2.101v5.625a.357.357 0 00.353.353h1.069a.402.402 0 01.305.68l-2.41 3.097a.63.63 0 01-.996 0l-1.648-2.098-.803-1.008a.401.401 0 01.313-.647h1.065a.357.357 0 00.357-.357V16.39a4.644 4.644 0 013.853-4.571.695.695 0 01.784.755zM25.938 15.802h-1.065a.353.353 0 00-.354.358v5.624a4.644 4.644 0 01-3.852 4.568.69.69 0 01-.784-.751v-.53a1.25 1.25 0 01.78-1.162 2.237 2.237 0 001.462-2.1v-5.625a.357.357 0 00-.354-.354h-1.068a.402.402 0 01-.301-.683l2.41-3.097a.63.63 0 01.992 0l1.58 2.009.859 1.096a.4.4 0 01-.305.647z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9.05)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgSwap;